(function () {
  'use strict';

  if (window.ScrublyStickyAtcLoaded) return;
  window.ScrublyStickyAtcLoaded = true;

  class StickyAtcBar {
    constructor(bar) {
      this.bar = bar;
      this.sectionId = bar.dataset.sectionId;
      this.variants = this.getVariants();
      this.select = bar.querySelector('.ssb-select');
      this.button = bar.querySelector('.ssb-btn');
      this.buttonLabel = bar.querySelector('.ssb-btn-label');
      this.buttonPrice = bar.querySelector('.ssb-btn-price');
      this.summary = bar.querySelector('.ssb-summary');
      this.productInfo = document.getElementById(`MainProduct-${this.sectionId}`) || document.querySelector('product-info[id^="MainProduct-"]');
      this.submitButton = this.productInfo?.querySelector('[name="add"], .product-form__submit') || null;
      this.luxWrap = document.querySelector('.lux-bundle-wrap');
      this.currentVariant = this.variants.find((variant) => String(variant.id) === this.select?.value) || this.variants[0] || null;
      this.resetTimer = null;
      this.visibilityFrame = null;
      this.scrollThreshold = Number(bar.dataset.scrollThreshold || 400);
      this.labels = {
        add: bar.dataset.buttonLabel || 'Add to cart',
        adding: bar.dataset.addingLabel || 'Adding...',
        added: bar.dataset.addedLabel || 'Added!',
        soldOut: bar.dataset.soldOutLabel || 'Sold out',
      };

      if (!this.button) return;
      if (window.location.pathname === '/cart') return;

      if (this.bar.parentElement !== document.body) {
        document.body.appendChild(this.bar);
      }

      this.bindEvents();
      this.updateFromCurrentVariant();
      this.updateVisibility();
    }

    getVariants() {
      const source = this.bar.querySelector('.ssb-variants-data');
      if (!source) return [];

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        console.error('Sticky ATC variants parse error', error);
        return [];
      }
    }

    bindEvents() {
      this.select?.addEventListener('change', () => {
        const variant = this.findVariant(this.select.value);
        this.currentVariant = variant;
        this.syncVariantToPage(variant);
        this.updateFromCurrentVariant();
      });

      this.luxWrap?.addEventListener('change', () => {
        window.setTimeout(() => {
          const variant = this.getCurrentVariantFromPage();
          if (!variant) return;
          this.currentVariant = variant;
          this.updateFromCurrentVariant();
        }, 50);
      });

      this.button.addEventListener('click', () => {
        this.addToCart();
      });

      document.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (!variant || !this.belongsToCurrentProduct(variant)) return;
        this.currentVariant = this.findVariant(variant.id) || variant;
        this.updateFromCurrentVariant();
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (!variant || !this.belongsToCurrentProduct(variant)) return;
          this.currentVariant = this.findVariant(variant.id) || variant;
          this.updateFromCurrentVariant();
        });
      }

      window.addEventListener('scroll', () => this.scheduleVisibilityUpdate(), { passive: true });
      window.addEventListener('resize', () => this.scheduleVisibilityUpdate());

      this.bodyObserver = new MutationObserver(() => this.scheduleVisibilityUpdate());
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      const drawer = this.getDrawer();
      if (drawer) {
        this.drawerObserver = new MutationObserver(() => this.scheduleVisibilityUpdate());
        this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
      }
    }

    belongsToCurrentProduct(variant) {
      return !variant.product_id || String(variant.product_id) === this.bar.dataset.productId;
    }

    findVariant(variantId) {
      return this.variants.find((variant) => String(variant.id) === String(variantId)) || null;
    }

    moneyFormat(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, this.bar.dataset.moneyFormat);
      }

      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }

    getDrawer() {
      return document.querySelector('cart-drawer');
    }

    isDrawerOpen() {
      const drawer = this.getDrawer() || document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
      const mobileMenuOpen =
        document.body.classList.contains('scrubly-mobile-menu-open') || !!document.querySelector('.scrubly-mobile-drawer.is-open');

      return (
        mobileMenuOpen ||
        document.body.classList.contains('cart-drawer-open') ||
        document.body.classList.contains('js-drawer-open') ||
        document.body.classList.contains('overflow-hidden') ||
        document.body.classList.contains('drawer-open') ||
        document.body.classList.contains('is-cart-open') ||
        !!(
          drawer &&
          (drawer.hasAttribute('open') ||
            drawer.open === true ||
            drawer.classList.contains('active') ||
            drawer.classList.contains('is-open') ||
            drawer.classList.contains('open') ||
            drawer.classList.contains('is-visible'))
        )
      );
    }

    isMainAtcVisible() {
      if (!this.submitButton) return false;
      const rect = this.submitButton.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    scheduleVisibilityUpdate() {
      if (this.visibilityFrame) return;

      this.visibilityFrame = window.requestAnimationFrame(() => {
        this.visibilityFrame = null;
        this.updateVisibility();
      });
    }

    updateVisibility() {
      if (this.isDrawerOpen()) {
        this.bar.classList.remove('ssb-show');
        this.bar.classList.add('ssb-force-hide');
        this.bar.setAttribute('aria-hidden', 'true');
        return;
      }

      this.bar.classList.remove('ssb-force-hide');

      if (this.submitButton) {
        const visible = this.isMainAtcVisible();
        this.bar.classList.toggle('ssb-show', !visible);
        this.bar.setAttribute('aria-hidden', String(visible));
        return;
      }

      const show = window.scrollY > this.scrollThreshold;
      this.bar.classList.toggle('ssb-show', show);
      this.bar.setAttribute('aria-hidden', String(!show));
    }

    updateFromCurrentVariant() {
      const variant = this.currentVariant;
      if (!variant) return;

      if (this.select && this.select.value !== String(variant.id) && this.findVariant(variant.id)) {
        this.select.value = String(variant.id);
      }

      if (this.buttonPrice) {
        const selectedOption = this.select?.options[this.select.selectedIndex];
        this.buttonPrice.textContent = selectedOption?.dataset.price || this.moneyFormat(variant.price);
      }

      if (this.summary) {
        this.summary.textContent = this.formatVariantSummary(variant);
      }

      this.button.disabled = !variant.available;
      this.buttonLabel.textContent = variant.available ? this.labels.add : this.labels.soldOut;
    }

    getCurrentVariantFromPage() {
      const variantInput = this.productInfo?.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (variantInput?.value) {
        return this.findVariant(variantInput.value);
      }

      return this.currentVariant;
    }

    formatVariantSummary(variant) {
      if (!variant) return '';

      if (variant.title && variant.title !== 'Default Title') {
        return variant.title;
      }

      return [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' • ');
    }

    syncVariantToPage(variant) {
      if (!variant) return;

      this.syncLuxInputs(variant);
      this.syncNativeOptionPickers(variant);
      this.updateNativeVariantId(variant.id);
    }

    syncLuxInputs(variant) {
      if (!this.luxWrap) return;

      [variant.option1, variant.option2, variant.option3]
        .filter(Boolean)
        .forEach((optionValue) => {
          Array.from(this.luxWrap.querySelectorAll('input[type="radio"][data-option-value]')).forEach((input) => {
            if (input.dataset.optionValue === optionValue && !input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
    }

    syncNativeOptionPickers(variant) {
      const optionValues = [variant.option1, variant.option2, variant.option3];

      this.productInfo?.querySelectorAll('variant-radios fieldset').forEach((fieldset, index) => {
        const optionValue = optionValues[index];
        if (!optionValue) return;

        const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => input.value === optionValue);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      this.productInfo?.querySelectorAll('variant-selects select, select[name^="options["]').forEach((select, index) => {
        const optionValue = optionValues[index];
        if (!optionValue) return;

        const hasOption = Array.from(select.options).some((option) => option.value === optionValue);
        if (hasOption && select.value !== optionValue) {
          select.value = optionValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          select.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }

    updateNativeVariantId(variantId) {
      this.productInfo?.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    getSectionIdsToRender() {
      const drawer = this.getDrawer();
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer.getSectionsToRender().map((section) => section.id);
      }

      return ['cart-drawer', 'cart-icon-bubble'];
    }

    setButtonState(state) {
      this.button.classList.remove('ssb-added', 'loading');

      if (state === 'adding') {
        this.button.classList.add('loading');
        this.button.disabled = true;
        this.buttonLabel.textContent = this.labels.adding;
        return;
      }

      if (state === 'added') {
        this.button.classList.add('ssb-added');
        this.button.disabled = true;
        this.buttonLabel.textContent = this.labels.added;
        return;
      }

      this.updateFromCurrentVariant();
    }

    async addToCart() {
      if (!this.currentVariant || !this.currentVariant.available) return;

      this.syncVariantToPage(this.currentVariant);
      this.setButtonState('adding');

      try {
        const formData = new FormData();
        formData.append('id', this.currentVariant.id);
        const pageQuantity = this.productInfo?.querySelector('input[name="quantity"]')?.value;
        formData.append('quantity', pageQuantity || 1);
        formData.append('sections', this.getSectionIdsToRender().join(','));
        formData.append('sections_url', window.location.pathname);

        const drawer = this.getDrawer();
        drawer?.setActiveElement?.(document.activeElement);

        const response = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add item');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'scrubly-sticky-atc',
            productVariantId: this.currentVariant.id,
            cartData: data,
          });
        }

        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents(data);
        }

        this.setButtonState('added');
        clearTimeout(this.resetTimer);
        this.resetTimer = window.setTimeout(() => this.setButtonState('idle'), 2200);
      } catch (error) {
        console.error(error);
        this.setButtonState('idle');
      }
    }
  }

  function initStickyBars() {
    document.querySelectorAll('.ssb-bar').forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';
      new StickyAtcBar(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBars);
  } else {
    initStickyBars();
  }

  document.addEventListener('shopify:section:load', initStickyBars);
})();
